import { coerceValueRef } from "../authContext";
import type { AuthDescriptor, ValueRefInput } from "../authDescriptor";

export function databasePasswordAuth(password: ValueRefInput): AuthDescriptor {
  return { type: "databasePassword", password: coerceValueRef(password) };
}

export function awsRdsIamAuth(input: {
  roleArn: ValueRefInput;
  issuer: string;
  host: ValueRefInput;
  port: ValueRefInput;
  username: ValueRefInput;
  region: ValueRefInput;
}): AuthDescriptor {
  return {
    type: "awsRdsIam",
    roleArn: coerceValueRef(input.roleArn),
    issuer: input.issuer,
    host: coerceValueRef(input.host),
    port: coerceValueRef(input.port),
    username: coerceValueRef(input.username),
    region: coerceValueRef(input.region),
  };
}
